import type { DynamicNavItem, NavItem } from './routing.types'

type NavLike = NavItem | DynamicNavItem

export const getNavItemPath = (to: NavLike['to'] | undefined): string =>
  typeof to === 'string' ? to : (to?.pathname ?? '')

export const collectNavPaths = (items: NavLike[]): string[] =>
  items.flatMap((item) => {
    const own = getNavItemPath(item.to)
    const nested = item.subItems ? collectNavPaths(item.subItems) : []
    return own ? [own, ...nested] : nested
  })

export const pathIsActive = (pathname: string, candidate: string): boolean =>
  candidate.length > 0 && (pathname === candidate || pathname.startsWith(`${candidate}/`))
